module.exports = __webpack_public_path__ + "static/media/micro-bio-ireland-ltd.801d58a4.jpg";